export const NOTIFICATIONS_LOCALSTORAGE_KEY = 'dismissed-notifications'
